<template>
  <v-layout text-xs-center fluid wrap style="padding: 0px;">
    <Dashboard />

  </v-layout>
</template>

<script>
  import Dashboard from '../components/Dashboard';

  export default {
    components: {
      Dashboard,
    },
    beforeUpdate() {

    },
    methods: {
      boom() {
        console.log('boom');
        let u = undefined;
        u.test();
      }
    }
  }
</script>
